import React, {useState} from 'react';

import css from './ProductGroupsComponent.module.css';
import {ButtonCreate} from "../../../ui/ButtonCreate/ButtonCreate";
import {
    ProductGroupsCreateProductGroupModal
} from "../settingSectionModals/ProductGroupsCreateProductGroupModal/ProductGroupsCreateProductGroupModal";
import ProductGroupsListComponent from "../ProductGroupsListComponent/ProductGroupsListComponent";


const ProductGroupsComponent = () => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        setIsOpen(true);
    };


    return (
        <section className={css.wrap}>

            <section className={css.btnBlock}>
                <ButtonCreate onClick={handleClick}/>
            </section>

            <section className={css.listBlock}>
                <ProductGroupsListComponent/>
            </section>

            {isOpen && <ProductGroupsCreateProductGroupModal setIsOpen={setIsOpen}/>}
        </section>
    );
};

export {ProductGroupsComponent};